import { i18n } from "../../i18n";
import {
  DefaultSideMenuHeader,
  openSideMenu,
  SideMenuSettings,
  updateSideMenuBody,
} from "./SideMenu";
import { CategoryMenu } from "./CategoryMenu";
import { select } from "@fruugo/utilities";
import { Icon } from "../Icon";

const { homeUrl, accountUrl, helpCentreUrl, cartUrl, whereIsMyOrderUrl } =
  window.pageUrls;

export function initMainMenu() {
  const config = {
    openMainMenuClass: ".js-open-main-menu",
  };

  const sideMenuSettings: SideMenuSettings = {
    position: "left",
    disableScroll: false,
  };

  function openMainMenu() {
    openSideMenu(<MainMenu />, sideMenuSettings);
  }

  select(config.openMainMenuClass)?.addEventListener("click", openMainMenu);
}

export const MainMenu = () => {
  const handleDepartmentSelection = () => updateSideMenuBody(<CategoryMenu />);

  return (
    <>
      <DefaultSideMenuHeader />
      <article>
        <section>
          <ul>
            <li>
              <a href={homeUrl} autoFocus={true} class="side-menu-item">
                <Icon name="home" />
                {i18n("home.title")}
              </a>
            </li>
            <li>
              <button
                type="button"
                class="side-menu-item has-children"
                onClick={handleDepartmentSelection}
              >
                <span class="d-flex align-items-center">
                  <Icon name="grid" />
                  {i18n("mobile.menu.shop.by.department")}
                </span>
                <Icon name="chevron-right" />
              </button>
            </li>
          </ul>
        </section>
        <section>
          <ul>
            <li>
              <a href={accountUrl} class="side-menu-item">
                <Icon name="account" />
                {i18n("header.account")}
              </a>
            </li>
            <li>
              <a href={cartUrl} class="side-menu-item">
                <Icon name="cart" />
                {i18n("header.cart.yourbasket")}
              </a>
            </li>
          </ul>
        </section>
        <section>
          <ul>
            <li>
              <a href={helpCentreUrl} class="side-menu-item">
                <Icon name="help" />
                {i18n("footer.contact-and-help")}
              </a>
            </li>
            <li>
              <a href={whereIsMyOrderUrl} class="side-menu-item">
                <Icon name="package" />
                {i18n("footer.wheres-my-order")}
              </a>
            </li>
            <li>
              <a href={helpCentreUrl + "#faq-header"} class="side-menu-item">
                <Icon name="quiz" />
                {i18n("footer.faqs")}
              </a>
            </li>
          </ul>
        </section>
      </article>
    </>
  );
};
